import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResultComponent } from './result.component';
import { DlgTakePictureComponent } from './dlg-take-picture/dlg-take-picture.component';
import { SharedMaterialModule } from '../../../shared/material.module';



@NgModule({
  declarations: [ResultComponent, DlgTakePictureComponent],
  imports: [
    CommonModule,
    SharedMaterialModule
  ],
  exports: [ResultComponent],
  entryComponents: [DlgTakePictureComponent]
})
export class ResultModule { }
